export const actionTypes = {
  SetMarketplaceFilter: '[SetMarketplaceFilter] Action',
};
